import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api.js';
import { actionIcon } from '../../lib/icons.jsx';
import './RecordDetail.css';

const parseData = (rec) => { try { return typeof rec.data === 'string' ? JSON.parse(rec.data) : (rec.data || {}); } catch (_) { return {}; } };
const fmt = (v, f) => {
  if (v == null || v === '') return '—';
  if (f.field_type === 'currency') return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(v);
  if (f.field_type === 'percent') return v + '%';
  if (f.field_type === 'select') { try { const o = JSON.parse(f.options_json || '[]').find((x) => x.value === v); return o ? o.label : v; } catch (_) { return v; } }
  return String(v);
};

const RecordDetail = () => {
  const { recordId } = useParams();
  const navigate = useNavigate();
  const [record, setRecord] = useState(null);
  const [object, setObject] = useState(null);
  const [fields, setFields] = useState([]);
  const [activities, setActivities] = useState([]);
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  const load = async () => {
    setLoading(true); setErr(null);
    try {
      const r = await api.get(`/byid/${recordId}`);
      const rec = r.data;
      setRecord(rec);
      if (rec) {
        const oR = await api.get('/objects');
        setObject((oR.data || []).find((o) => o.id === rec.object_id));
        const fR = await api.get(`/objects/${rec.object_id}/fields`);
        setFields(fR.data || []);
      }
      const aR = await api.get(`/activities/${recordId}`);
      setActivities(aR.data || []);
    } catch (e) { setErr(e.message); } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [recordId]);

  const addNote = async () => {
    if (!note.trim() || !record) return;
    try {
      await api.post('/activities', { object_id: record.object_id, record_id: record.id, type: 'note', body: note });
      setNote(''); load();
    } catch (e) { setErr(e.message); }
  };

  if (loading) return <div className="gencrm_ws_empty">A carregar registo...</div>;
  if (err) return <div className="gencrm_ws_error">Erro: {err}</div>;
  if (!record) return <div className="gencrm_ws_empty">Registo não encontrado.</div>;

  const data = parseData(record);
  return (
    <div className="gencrm_detail">
      <button className="gencrm_btn gencrm_btn--secondary gencrm_detail__back" onClick={() => navigate(-1)}>{actionIcon('back', 16)} Voltar</button>
      <div className="gencrm_detail__head">
        <div className="gencrm_detail__num">{record.record_number}</div>
        <h2 className="gencrm_detail__title">{record.name}</h2>
        {object && <span className="gencrm_detail__obj">{object.label_singular}</span>}
      </div>

      <div className="gencrm_detail__grid">
        {fields.map((f) => (
          <div key={f.id} className="gencrm_detail__field">
            <div className="gencrm_detail__label">{f.label}</div>
            <div className="gencrm_detail__value">{fmt(f.is_primary_label ? record.name : data[f.name], f)}</div>
          </div>
        ))}
      </div>

      <div className="gencrm_detail__section">
        <h3>Atividades / Notas</h3>
        <div className="gencrm_detail__note">
          <textarea rows={2} placeholder="Adicionar nota..." value={note} onChange={(e) => setNote(e.target.value)} className="gencrm_field_input" />
          <button className="gencrm_btn" onClick={addNote}>Adicionar nota</button>
        </div>
        <div className="gencrm_detail__timeline">
          {activities.length === 0 ? <div className="gencrm_ws_empty">Sem atividades.</div> :
            activities.map((a) => (
              <div key={a.id} className="gencrm_detail__act">
                <span className="gencrm_detail__acttype">{a.type}</span>
                <span className="gencrm_detail__actbody">{a.body || a.subject}</span>
                <span className="gencrm_detail__actdate">{a.created_by} · {new Date(a.created_at).toLocaleString('pt-PT')}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default RecordDetail;
